// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"SiteTotalBreakersLiveReadingTable_cardTitle__1gKuo"};